import React from 'react';

/**
 * Replai's mascot "Rei": a chubby speech-bubble with friendly eyes and a smile.
 * Single component used as both logo and avatar. Scales with `size` (px).
 */
const ReplaiMark = ({ size = 40, className = '', animated = false }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
    width={size}
    height={size}
    className={className}
    fill="none"
    aria-label="Replai"
  >
    <defs>
      <linearGradient id="rei-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#FF8A7A" />
        <stop offset="100%" stopColor="#FF6B5A" />
      </linearGradient>
    </defs>
    <path
      d="M22 12h52c5.5 0 10 4.5 10 10v38c0 5.5-4.5 10-10 10H44l-14 12c-1.9 1.6-4.7.3-4.7-2.2V70H22c-5.5 0-10-4.5-10-10V22c0-5.5 4.5-10 10-10z"
      fill="url(#rei-body)"
    />
    <ellipse cx="28" cy="24" rx="8" ry="3" fill="#fff" opacity="0.35" />
    <g className={animated ? 'rei-eyes' : undefined}>
      <circle cx="36" cy="40" r="5" fill="#2A2623" />
      <circle cx="60" cy="40" r="5" fill="#2A2623" />
      <circle cx="37.5" cy="38.5" r="1.6" fill="#fff" />
      <circle cx="61.5" cy="38.5" r="1.6" fill="#fff" />
    </g>
    <path
      d="M38 52c2.8 3.6 7 5.6 10 5.6 3 0 7.2-2 10-5.6"
      stroke="#2A2623"
      strokeWidth="3.2"
      strokeLinecap="round"
      fill="none"
    />
    <circle cx="28" cy="52" r="2.6" fill="#fff" opacity="0.4" />
    <circle cx="68" cy="52" r="2.6" fill="#fff" opacity="0.4" />
  </svg>
);

export default ReplaiMark;
